import { render, staticRenderFns } from "./SmartfeedPage3.vue?vue&type=template&id=3f47d8cb&scoped=true&"
import script from "./SmartfeedPage3.vue?vue&type=script&lang=js&"
export * from "./SmartfeedPage3.vue?vue&type=script&lang=js&"
import style0 from "./SmartfeedPage3.vue?vue&type=style&index=0&id=3f47d8cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47d8cb",
  null
  
)

export default component.exports